<p>abstract-verify-payment works!</p>
